"use strict";

var config = require("app/util/config/config");
var PromptList = require("app/shared/components/Prompt/prompt-list");
var PromptContainer = require("app/shared/components/Prompt/prompt-container");
var SAFE_DAYS_TO_UNDO = 7;
var AGENDOR_SUPPORT_PHONE = config.support.phone;
var AGENDOR_SUPPORT_EMAIL = config.support.email;
var UNDO_IMPORT_VALIDATION = config.app.riskUndoImportValidation;

var UndoImportPrompt = React.createClass({
  propTypes: {
    importId: React.PropTypes.number.isRequired,
    object: React.PropTypes.string.isRequired,
    date: React.PropTypes.string.isRequired,
    onClose: React.PropTypes.func
  },
  getInitialState: function() {
    return { firstConfirmation: true };
  },
  getOnConfirm: function() {
    if (this.isSafeUndo()) {
      return this.undoImport;
    } else {
      return this.showRiskyPrompt;
    }
  },
  isSafeUndo: function() {
    var currentDate = Date.now();
    var importDate = new Date(this.props.date);
    var differenceInMillis = (currentDate - importDate);
    var dayInMillis = 1000 * 60 * 60 * 24;
    var differenceInDays = Math.floor(differenceInMillis / dayInMillis);

    return differenceInDays < SAFE_DAYS_TO_UNDO;
  },
  undoImport: function() {
    window.location.href = "/src/php/sistema/http/obj/Importacao/desfazer.php?id=" + this.props.importId + "&obj=" + this.props.object;
  },
  showRiskyPrompt: function() {
    this.setState({firstConfirmation: false});
  },
  render: function() {
    if(this.state.firstConfirmation){
      return <SafeUndoImportPrompt object={this.props.object} onConfirm={this.getOnConfirm()} onClose={this.props.onClose} />;
    } else {
      return <RiskyUndoImportPrompt supportContact={this.props.supportContact}
         onClose={this.props.onClose} undoImport={this.undoImport}
         validation={this.props.validation} />;
    }
  }
});

var SafeUndoImportPrompt = React.createClass({
  propTypes: {
    object: React.PropTypes.string.isRequired,
    onConfirm: React.PropTypes.func.isRequired,
    onClose: React.PropTypes.func
  },
  checklistWarnings: function() {
    var warnings = [];

    if(this.props.object != undefined){
      var lowerObj = this.props.object.toLowerCase();

      if(lowerObj == "empresa") {
        warnings.push({checked:false, text: "Todas as empresas dessa importação serão excluídas."});
        warnings.push({checked:false, text: "Todas as pessoas e negócios relacionados a essas empresas serão mantidos, porém ficarão sem empresa relacionada."});
        warnings.push({checked:false, text: "Todos os comentários e tarefas relacionadas a essas empresas serão excluídas."});
      } else if(lowerObj == "pessoa") {
        warnings.push({checked:false, text: "Todas as pessoas dessa importação serão excluídas."});
        warnings.push({checked:false, text: "Todos os negócios relacionados a essas pessoas serão mantidos, porém ficarão sem pessoa relacionada."});
        warnings.push({checked:false, text: "Todos os comentários e tarefas relacionadas a essas pessoas serão excluídas."});
      } else if(lowerObj == "negocio") {
        warnings.push({checked:false, text: "Todos os negócios dessa importação serão excluídos."});
        warnings.push({checked:false, text: "Todos os comentários e tarefas relacionadas aos negócios serão excluídas."});
      } else if(lowerObj == "comentario") {
        warnings.push({checked:false, text: "Todos os comentários e tarefas dessa importação serão excluídas"});
      }

      warnings.push({checked:false, text: "Entendo que este é um processo irreversível."});
    }

    return warnings;
  },
  render: function() {
    var props = {
      title:"Deseja desfazer esta importação?",
      text: "Marque as opções que realizaremos na sua conta:",
      hideWarningIcon:false,
      buttonText:"Confirmar perdas e desfazer importação",
      buttonClasses:"btn btn-danger",
      autoClose: false,
      isOpen: true,
      onClose: this.props.onClose,
      checkboxItems: this.checklistWarnings(),
      onConfirm: this.props.onConfirm
    };

    return <PromptList {...props}></PromptList>;
  }
});

var RiskyUndoImportPrompt = React.createClass({
  propTypes: {
    undoImport: React.PropTypes.func.isRequired,
    onClose: React.PropTypes.func
  },
  onConfirmRiskyUndo: function(inputText) {
    if(inputText.value == UNDO_IMPORT_VALIDATION){
      this.props.undoImport();
    } else {
      var message = "Entre em contato com a nossa equipe para poder prosseguir.";
      this.refs["prompt"].showError(message);
    }
  },
  render: function() {
    var riskProps = {
      type: "prompt",
      title:"Atenção!",
      text: "Esta é uma importação feita há mais de 7 dias. Para segurança e integridade de seus dados, caso queira realmente desfazer esta importação, entre em contato com a nossa equipe pelo telefone " + AGENDOR_SUPPORT_PHONE + " ou pelo email " + AGENDOR_SUPPORT_EMAIL + ".",
      inputPlaceholder: "Cole aqui o código informado pelo nosso suporte",
      hideWarningIcon:false,
      buttonText:"Confirmar perdas e desfazer importação",
      buttonClasses:"btn btn-danger",
      autoClose: false,
      onClose: this.props.onClose,
      isOpen: true,
      onConfirm: this.onConfirmRiskyUndo
    };

    return <PromptContainer {...riskProps} ref="prompt"></PromptContainer>;
  }
});

module.exports = UndoImportPrompt;



// WEBPACK FOOTER //
// ./app/screens/Import/components/UndoImportPrompt/undo-import-prompt.jsx